import { render, staticRenderFns } from "./MemberAreaStudents.vue?vue&type=template&id=63ef0134&scoped=true&"
import script from "./MemberAreaStudents.vue?vue&type=script&lang=js&"
export * from "./MemberAreaStudents.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaStudents.vue?vue&type=style&index=0&id=63ef0134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef0134",
  null
  
)

export default component.exports